/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Access_SelectedInputs */



/**
* | output |
* | --- |
* | "Selected members" |
*
* @param {External_Apis_Space_Access_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_access_selected = /** @type {((inputs?: External_Apis_Space_Access_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Access_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Mitglieder")
	return /** @type {LocalizedString} */ ("Selected members")
});